
import { Vue, Component, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";

@Component
export default class UAbbr extends Vue {
  // Props

  @Prop({ default: undefined })
  public readonly value!: string;

  @Prop({ default: undefined })
  public readonly tooltip!: string;

  @Prop({ default: "is-top" })
  public readonly position!: string;

  // Render

  public render(h: CreateElement) {
    const slot = this.$scopedSlots?.default && this.$scopedSlots.default({});
    if (this.tooltip)
      return h(
        "b-tooltip",
        {
          props: {
            type: "is-dark",
            size: this.tooltip.length <= 64 ? "is-small" : undefined,
            label: this.tooltip,
            position: this.position,
            multilined: this.tooltip.length >= 32
          }
        },
        [h("span", { class: "u-abbr" }, slot || this.value)]
      );
    return slot || h("span", {}, this.value);
  }
}
